<template>
  <v-app class="notoSans">
    <router-view/>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({
    //
  })
}
</script>

<style lang="scss">
html, body { margin: 0; height: 100%; overflow: hidden ;}
@import url('https://cdn.jsdelivr.net/gh/lazywasabi/thai-web-fonts@6/fonts/NotoSansThai/NotoSansThai.css');
.v-application {
font-family: 'Noto Sans Thai', sans-serif !important;
background-color:var(--v-grayfooter-base) !important;
}
#app{
    font-family: Noto Sans Thai, sans-serif !important;
    background-size: cover;
    background-repeat: repeat-x;
}
.notoSans {
 font-family: 'Noto Sans Thai', sans-serif !important;
 word-wrap: break-word;
}
.theme--light.v-input--is-disabled input, .theme--light.v-input--is-disabled textarea {
    color: rgba(0, 0, 0, 0.88) !important;
}
.swal2-popup {
  border-radius: 30px !important;
  font-family: 'Noto Sans Thai', sans-serif !important;
  padding-bottom: 50px !important;
  padding-right: 5px !important;
}
.v-dialog {
  border-radius: 25px !important;
}

  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: 'white';
    border-radius: 10px;
    margin-top: 12px;
    margin-bottom: 12px;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #0F955D;
    border-radius: 10px;
    margin-top: 12px;
    margin-bottom: 12px;
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #30b37c;
  }
</style>
